// 公文卡片的純資料層（#1620）。🔴 卡片資料就是送給模型的那一份工具結果：
// 這裡只從工具結果挑出主旨、機關、日期，不另外向伺服器要任何東西。

/** 列表結果的附件型別；與 src/tools/document 兩支工具的常數同值，由測試釘住。 */
export const DOCUMENTS_ATTACHMENT = 'documents'
/** 明細結果的附件型別 */
export const DOCUMENT_ATTACHMENT = 'document'

export interface DocumentCard {
  documentId: string
  subject: string
  bureau: string
  issueDate: string
}

const text = (value: unknown): string => (typeof value === 'string' ? value : '')

// 形狀對不上的一筆直接略過：畫少一張卡，總比整條對話白掉好。
const toCard = (value: unknown): DocumentCard[] => {
  if (typeof value !== 'object' || value === null) return []
  const source = value as Record<string, unknown>
  const documentId = text(source.documentId)
  if (!documentId) return []
  return [{
    documentId,
    subject: text(source.subject),
    bureau: text(source.bureau),
    issueDate: text(source.issueDate),
  }]
}

/** 工具結果 → 要畫的卡片。列表取 items、明細取 document；查不到時是空陣列。 */
export const toDocumentCards = (content: unknown): DocumentCard[] => {
  if (typeof content !== 'object' || content === null) return []
  const source = content as Record<string, unknown>
  if (source.attachmentType === DOCUMENTS_ATTACHMENT && Array.isArray(source.items)) {
    return source.items.flatMap(toCard)
  }
  if (source.attachmentType === DOCUMENT_ATTACHMENT && source.found === true) {
    return toCard(source.document)
  }
  return []
}
